import React, { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import ButtonForModal from "../../../../components/ButtonForModal";
import { PencilSquareIcon } from "@heroicons/react/24/solid";
import {
  DisableOfficeField,
  DisableVendorField,
  officeVendorAddState,
  officeVendorEditState,
  OfficeVendorModal,
  OfficeVendorSvcViewData,
  officeVendorViewFromOffice,
  rowForEditOfficeSettings,
  selectedRowsStateOfcVendor,
} from "../../OfficeSettings/atoms/atoms";
import { useGetOfcVendorServiceForEdit } from "../../OfficeSettings/hooks/useGetOfcVendorSvcForEdit";
import { OfficeVendorServiceModal } from "../../OfficeSettings/modals/OfficeVendorServiceModal";
import OfficeVendorServiceView from "../../OfficeSettings/views/OfficeVendorServiceView";
import OfficeVendorServiceForm from "../../OfficeSettings/forms/OfficeVendorServiceForm";
import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";
import useDeactivateOfcVendorSvc from "../../OfficeSettings/hooks/useDeactivateOfficeVendorService";
import { selectedRowsStateOVS } from "../atoms/atoms";
import { toast } from "../../../../components/toastNotification";
import { useQueryClient } from "react-query";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";

// interface VendorOfficesTableProps {}
export const VendorOfficesTable = ({ data }) => {
  const queryClient = useQueryClient();
  const [ofcVendorServiceShow, setOfcVendorServiceShow] =
    useRecoilState(OfficeVendorModal);
  const [rowViewData, setRowViewData] = useRecoilState(OfficeVendorSvcViewData);
  const setRowToEdit = useSetRecoilState(rowForEditOfficeSettings);
  const [isOfficeVendorServiceEditState, setOfficeVendorServiceEditState] =
    useRecoilState(officeVendorEditState);
  const [isOfficeVendorServiceAddState, setOfficeVendorServiceAddState] =
    useRecoilState(officeVendorAddState);
  const [, setDisableVendorField] = useRecoilState(DisableVendorField);
  const [, setDisableOfficeField] = useRecoilState(DisableOfficeField);
  const [selectedRowsToDelete, setSelectedRowsToDelete] =
    useRecoilState(selectedRowsStateOVS);
  const [disabledButton, setDisabledButton] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [, setShowOfficeVendorFromOffice] = useRecoilState(
    officeVendorViewFromOffice
  );

  const userPermissions = useRecoilValue(permissionsSelector);
  const editVendorOffice = PERMISSIONS.permission_vendor_office_edit;
  const deactivateVendorOffice = PERMISSIONS.permission_vendor_office_delete;
  const onClickOfficeVendorService = (rowData) => {
    setOfcVendorServiceShow(true);
    setRowViewData({
      ...rowData,
      vendorName: rowData.vendorName,
      servicesProvided: rowData.servicesProvidedName,
    });
    setShowOfficeVendorFromOffice(false);
  };

  const {
    mutate: getOfcVendorServiceForEdit,
    isLoading: OfcVendorServiceoading,
  } = useGetOfcVendorServiceForEdit();

  const {
    mutate: BulkDeleteVendor,
    isSuccess: deacSuccess,
    isError: deacError,
    data: deacResult,
    reset: resetDeacData,
  } = useDeactivateOfcVendorSvc();

  const handleEdit = (rowDetails) => {
    getOfcVendorServiceForEdit(rowDetails.recordNumber, {
      onSuccess: (res) => {
        setRowToEdit({
          ...res,
          inactiveAccount: res.inactiveAccount ? "True" : "False",
          vendorCode: rowDetails.vendorCode,
        });
        if (!OfcVendorServiceoading) setOfficeVendorServiceEditState(true);
      },
    });
    setDisableVendorField(true);
  };
  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows
      .filter((x) => x.isActive)
      .map((r) => {
        const { tableData, ...rows } = r;
        return rows;
      });
    setSelectedRowsToDelete(forDelete);
  };
  const handleBulkDelete = () => {
    const ids = selectedRowsToDelete?.map((row) => row.recordNumber);
    const data = { id: ids, fromModule: "Vendor" };
    BulkDeleteVendor(data);
    //setSelectedRowsToDelete(ids);
    setOpenModalDelete(false);
    setDisabledButton(false);
  };

  useEffect(() => {
    setSelectedRowsToDelete([]);
  }, [setSelectedRowsToDelete]);

  if (deacSuccess && deacResult) {
    if (deacResult.status === 201 || deacResult.status === 200) {
      toast.fire(
        "Success",
        "Office Vendor Services were deactivated successfully",
        "success"
      );
      queryClient.invalidateQueries("GetVendorOffices");
      setSelectedRowsToDelete([]);
    } else if (deacResult.status === 500) {
      if (
        deacResult.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available" ||
        deacResult.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available"
      ) {
        toast.fire(
          "Warning",
          "Office Vendor Services were successfully deactivated, but " +
            deacResult.data.message,
          "warning"
        );
        setSelectedRowsToDelete([]);
      } else {
        toast.fire(
          "Bulk deactivation of Office Vendor Services failed",
          "Server Error: Cannot deactivate Office Vendor Services",
          "error"
        );
      }

      queryClient.invalidateQueries("GetVendorOffices");
    } else {
      toast.fire(
        "Bulk deactivation of Office Vendor Services failed",
        "Server Error: Cannot deactivate Office Vendor Services",
        "error"
      );
      queryClient.invalidateQueries("GetVendorOffices");
    }
    resetDeacData();
  }

  const matColumns = [
    {
      title: "Record Number",
      field: "recordNumber",
      render: (rowdata) => {
        return (
          <span className="pr-2 items-center flex">
            <div
              className="blueAndBold underline expandedData fontExpand text-xs cursor-pointer"
              onClick={() => onClickOfficeVendorService(rowdata)}
            >
              {rowdata.recordNumber
                ? "MS-" + String(rowdata?.recordNumber).padStart(4, "0")
                : ""}
            </div>
          </span>
        );
      },
      customFilterAndSearch: (term, rowData) =>
        ("MS-" + String(rowData?.recordNumber)?.padStart(4, "0"))
          .toLowerCase()
          .indexOf(term.toLowerCase()) !== -1,
    },
    {
      title: "Office",
      field: "officeName",
    },
    {
      title: "Services Provided",
      field: "servicesProvidedName",
    },
    {
      title: "Account Number",
      field: "accountNumber",
    },
    {
      title: "Meter Number",
      field: "meterNumber",
    },
    {
      title: "Status",
      field: "status",
      // render: (rowData) => {
      //   return (
      //     <span className="pr-2">
      //       {" "}
      //       {rowData?.isActive ? "Active" : "InActive"}{" "}
      //     </span>
      //   );
      // },
    },
    {
      title: "Action/s",
      render: (rowData) => {
        return (
          <div className=" flex ">
            {userPermissions.includes(editVendorOffice) && (
              <ButtonForModal
                className={
                  " border border-quaternary text-white bg-quaternary  "
                }
                onClick={() => {
                  handleEdit(rowData);
                }}
                isDisabled={false}
              >
                <PencilSquareIcon className="h-4 w-4" />
                Edit
              </ButtonForModal>
            )}
          </div>
        );
      },
    },
  ];

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${
      selectedRowsToDelete?.length
    } ${
      selectedRowsToDelete
        ? selectedRowsToDelete?.length > 1
          ? "Office Vendor Services"
          : "Office Vendor Service"
        : ""
    } ?`}</div>
  );

  const closeOfficeVendorModal = () => {
    setRowViewData(undefined);
    setOfficeVendorServiceAddState(false);
    setOfficeVendorServiceEditState(false);
    setDisableOfficeField(false);
    setDisableVendorField(false);
    setOfcVendorServiceShow(false);
  };

  return (
    <div className="w-full p-2 bg-white">
      <div className="rounded-lg border-primary box-shadow">
        <div className="overflow-x-auto grid grid-row">
          <MaterialTableTS
            data={data}
            isLoading={false}
            columns={matColumns}
            showTitle={false}
            selection={userPermissions.includes(deactivateVendorOffice)}
            showToolbar={true}
            toolbarSearch={true}
            selectedRows={selectedRowsToDelete}
            setConfirmModalOpen={setOpenModalDelete}
            onSelectionChange={handleSelectedRowsChange}
          />
        </div>
      </div>

      {ofcVendorServiceShow && (
        <OfficeVendorServiceModal
          showFullView={ofcVendorServiceShow}
          closeFullView={closeOfficeVendorModal}
          producerCodeId={0}
        >
          <OfficeVendorServiceView data={rowViewData ? rowViewData : data} />
        </OfficeVendorServiceModal>
      )}
      {(isOfficeVendorServiceAddState || isOfficeVendorServiceEditState) && (
        <OfficeVendorServiceModal
          showFullView={
            isOfficeVendorServiceAddState || isOfficeVendorServiceEditState
          }
          closeFullView={closeOfficeVendorModal}
          producerCodeId={0}
        >
          <OfficeVendorServiceForm data={data} />
        </OfficeVendorServiceModal>
      )}

      <ConfirmBoxDelete
        ModalTitle="Deactivate Office Vendor Service"
        qConfirmation={deleteMessage}
        isOpen={openModalDelete}
        onClose={() => setOpenModalDelete(false)}
        onClickFunction={handleBulkDelete}
        cancelButtonRef={undefined}
      />
    </div>
  );
};
